import { numberToPrettyString } from '@cian/utils';
import * as React from 'react';

import { Container } from '../../components/Container';
import { Link } from '../../components/Link';
import { Text } from '../../components/Text';
import { SIZE_8, SIZE_16, SIZE_20 } from '../../constants/sizes';
import { IRoomCounter } from '../../types/newbuilding/newbuilding';
import { memoizeWith } from 'ramda';

interface IBuilderStatsByRoomsProps {
  counters: IRoomCounter[] | null;
  setPage(url: string): void;
}

const RoomTypes = [
  { key: 'oneRoom', name: '1 комнатные', idx: 0 },
  { key: 'twoRoom', name: '2 комнатные', idx: 1 },
  { key: 'threeRoom', name: '3 комнатные', idx: 2 },
  { key: 'fourRoom', name: '4 комнатные', idx: 3 },
  { key: 'fiveRoom', name: '5 комнатные', idx: 4 },
  { key: 'large', name: '6+ комнатные', idx: 5 },
  { key: 'openPlan', name: 'Свободный план', idx: 6 },
  { key: 'studio', name: 'Студии', idx: 7 },
];

const getRoomTypeMemo = memoizeWith(JSON.stringify, (roomCount: string) => {
  return RoomTypes.find(type => type.key === roomCount);
});

export interface IRoomCounterLinkKit {
  offersCount: number;
  label: string;
  url: string;
}

const getSortedStats = (stats: IRoomCounter[]): IRoomCounterLinkKit[] => {
  const sorted: IRoomCounterLinkKit[] = [];

  stats.forEach((stat: IRoomCounter) => {
    const { roomCount, offersCount, url } = stat;
    const roomType = getRoomTypeMemo(roomCount);

    if (roomType) {
      sorted[roomType.idx] = { offersCount, label: roomType.name, url };
    }
  });

  return sorted;
};

export const BuilderStatsByRooms: React.StatelessComponent<IBuilderStatsByRoomsProps> = (props) => {
  const { counters, setPage } = props;

  if (counters === null) {
    return null;
  }

  const sortedCounters = getSortedStats(counters);

  return (
    <Container
      columnCount={4}
      margin={`${SIZE_16} 0 ${SIZE_20} 0`}
    >
      {sortedCounters.map((counter: IRoomCounterLinkKit, index: number) => {
        if (!counter) {
          return null;
        }

        return (
          <Container
            key={index}
            margin={`0 0 ${SIZE_8} 0`}
            display="flex"
          >
            <Link
              url={counter.url}
              onClick={() => setPage(counter.url)}
              notChangeLocation
            >
              <Text
                fontSize={14}
                lineHeight={20}
                color="blue"
                colorHovered="red"
              >
                {counter.label}
              </Text>
            </Link>
            <Container
              padding={`0 ${SIZE_8}`}
              display="inline"
            >
              <Text
                fontSize={12}
                color="gray_4"
                whiteSpace="nowrap"
              >
                {numberToPrettyString(counter.offersCount)}
              </Text>
            </Container>
          </Container>
        );
      })}
    </Container>
  );
};
